export default __webpack_public_path__ + "static/media/image-11.43d081f3.png";